import * as React from 'react';

import BasePaycodeListLayout from './BasePaycodeListLayout';
import EditPaycodePopup from '../containers/codes/EditPaycodePopup';


export default (params) => {
  const { paycodeId } = params;

  return BasePaycodeListLayout(
    <EditPaycodePopup paycodeId={paycodeId} />
  );
};
